import React from 'react';
import { servicesData } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

export const Services = () => {
  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto space-y-6">
            <h1 className="text-5xl font-bold text-gray-900">Cloud Services & Solutions</h1>
            <p className="text-xl text-gray-600">
              Comprehensive cloud infrastructure services designed to accelerate your digital transformation
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {servicesData.map((service, index) => (
            <div
              key={service.id}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="rounded-2xl shadow-xl w-full"
                />
              </div>
              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="inline-block px-4 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                  Service {service.id}
                </div>
                <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
                <p className="text-lg text-gray-600 leading-relaxed">{service.description}</p>
                <div className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <CheckCircle className="w-5 h-5 text-blue-700 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
                <Button className="bg-blue-700 hover:bg-blue-800" asChild>
                  <Link to="/contact">Learn More</Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="text-3xl font-bold text-gray-900">Need a Custom Solution?</h2>
          <p className="text-lg text-gray-600">
            Our team can design a tailored cloud architecture that meets your specific requirements
          </p>
          <Button size="lg" className="bg-blue-700 hover:bg-blue-800" asChild>
            <Link to="/contact">Request Consultation</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Services;